export function scrollTo(x = 0, y = 0) {
  window.scrollTo(x, y);
}
